import React from 'react';
import StepCard from './StepCard';



const Steps = () => {
    const stepsData = [
        {
            "id": 1,   
            "image": "https://i.ibb.co/BwZb6PT/avatar.png",
            "title": "Create a free account",
            "description": "Globally integrate global e-markets for distributed experiences. Dramatically implement intermandated web-readiness."
        },
        {
            id: 2,
            "image": "https://i.ibb.co/wsDyCgH/car.png",
            "title": "Post your free car",
            "description": "Globally integrate global e-markets for distributed experiences. Dramatically implement intermandated web-readiness."
        },
        {
            id: 3,
            "image": "https://i.ibb.co/T2XQtPW/sell-icon.png",
            "title": "Sold or Buy",
            "description": "Globally integrate global e-markets for distributed experiences. Dramatically implement intermandated web-readiness."
        },
    ]

    return (
        <div className=' mt-5 pt-5 pb-10 bg-[#fffafa]'>
            <div className="container-size">
            <div className="step-card-container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 text-center mt-10 gap-10">
                {
                    stepsData.map(data => <StepCard key={data.id}
                    data={data}
                    ></StepCard>)
                }                                                                    
            </div>
        </div>
        </div>
    );
};

export default Steps;